<template>
  <div class="va-row">
    <div class="flex md12 xs12">
      <!-- :methodList="methodList" -->
      <virtual-account-detail-filter
        @searchReset="searchReset"
        @searchOrder="searchOrder"
        :value-app.sync="filterData.valueApp"
        :value-currency.sync="filterData.valueCurrency"
        :value-method.sync="filterData.valueMethod"
        :value-status.sync="filterData.valueStatus"
        :value-time.sync="filterData.valueTime"
        :curr-time-zone.sync="currTimeZone"
        :date-vals.sync="dateVals"
        :value-mode.sync="filterData.valueMode"
        :search-val.sync="filterData.searchVal"
        :appList="appList"
        :currencyList="currencyList"
        :statusList="statusList"
        :timeModeList="timeModeList"
        :timeZoneList="timeZoneList"
        :pickerOptions="pickerOptions"
        :modeList="modeList"
        :fileTypeOptions="fileTypeOptions"
        :queryDate="queryDate"
      />
    </div>

    <div class="flex xs12 md12 w-table">
      <vuestic-widget id="dategridPayOrder">
        <div class="table-responsive">
          <table class="table table-striped first-td-padding">
            <thead>
            <tr>
              <th v-for="(item, index) in tableHeaderList" :key="index">
                {{ item.label | translate }}
              </th>
            </tr>
            </thead>
            <tbody v-if="list && list.length > 0">
            <tr v-for="(item, index) in list" :key="index">
              <td>{{ item.trade_no }}</td>
              <td>{{ item.out_trade_no }}</td>
              <td>{{ item.pay_currency }} {{ item.pay_amount }}</td>
              <td>{{ item.account_number }}</td>
              <td>{{ item.provider }}</td>
              <td>{{ $t("t.success") }}</td>
              <td>{{ item.buyer_id }}</td>
              <td>{{ item.create_time }}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="11" v-text="noData"></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="block" v-if="isMobile === 'pc'">
          <pagination
            v-show="total > 0"
            :total="total"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :page.sync="page"
            :limit.sync="limit"
            @pagination="orderData"
          />
        </div>
        <div class="block" v-else>
          <pagination
            v-show="total > 0"
            :total="total"
            layout="total, prev, pager, next"
            background
            :page.sync="page"
            :limit.sync="limit"
            @pagination="orderData"
          />
        </div>
      </vuestic-widget>
    </div>
  </div>
</template>

<script>
  import VirtualAccountDetailFilter from "./VirtualAccountDetailFilter.vue"
  import Scrollbar from "@/vuestic-theme/vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue";
  import Pagination from "@/components/Pagination";

  import {
    request,
  } from "@/utils/utils.js";
  let moment = require("moment-timezone");

  export default {
    name: "Recurrings",
    data() {
      return {
        filterData: {
          valueApp: "",
          valueCurrency: "",
          valueMethod: "",
          valueStatus: "",
          valueTime: "1",
          valueMode: "1",
          searchVal: ""
        },
        currTimeZone: "America/Sao_Paulo",
        dateVals: [],
        transferAccountBean:{},
        appList: [],
        currencyList: [],
        // methodList: [],
        // 订单初始化 INITIAL(1000, "Initial"),正常循环中（等待下次付费） ACTIVE(2000, "Active"),付费中 CHARGING(2001, "Charging"),风控中 CONTROLLING(2002, "Controlling"),取消订阅 CANCEL(3000, "Cancelled"),逾期 PAST_DUE(3001, "Past Due"),正常关闭 CLOSE(4000, "Closed"),拒绝 REFUSED(5000, "Refused")
        statusList: [
          {"desc": "All", "code": ""},
          {"desc": "ACTIVE", "code": "1"},
          {"desc": "CANCELED", "code": "0"},
        ],
        // 1:create_time, 2:update_time, 3:next_time
        timeModeList: {
          "Create Time": "1"
        },
        timeZoneList: [
          "America/Sao_Paulo",
          "Etc/GMT",
          "Asia/Shanghai",
          "America/Mexico_City",
          "America/Bogota", // 哥伦比亚
          "America/Santiago", // 智利 America/Santiago 首都  Pacific/Easter America/Punta_Arenas
          "America/Lima", // 秘鲁
          "America/Panama", // 巴拿马
          "America/Costa_Rica", // 哥斯达黎加
          "America/Guayaquil", // 厄瓜多尔 America/Guayaquil Pacific/Galapagos
        ],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() + 24 *60* 60 * 1000;
          },
        },
        modeList: {
          // "Transaction ID": "1",
          "BuyerId": "1",
          "AccountNumber": "2",
          "ID": "3",
          // Email: "5",
          // "User Identify": "6",
        },
        fileTypeOptions: {
          "XLSX": "xlsx",
          "CSV": "csv"
        },
        tableHeaderList: [
          // { label: "tables.listing.recurring_transaction_id", key: "transactionId", id: 0 },
          {
            label: "tables.listing.recurring_transaction_id",
            key: "id",
            id: 0,
          },
          {
            label: "tables.listing.merchantReference",
            key: "merchantReference",
            id: 1,
          },
          {
            label: "tables.listing.amount",
            key: "accountNumber",
            id: 2,
          },
          {
            label: "tables.listing.transfer_account_number",
            key: "accountNumber",
            id: 3,
          },
          { label: "tables.listing.provider", key: "provider", id: 4 },
          { label: "tables.listing.recurring_status", key: "status", id: 7 },
          { label: "tables.listing.recurring_buyer_id", key: "buyerId", id: 8 },
          { label: "tables.listing.recurring_create_time", key: "createTime", id: 12 },
        ],
        list: null, // 请求回来填充表格的数据
        total: 0, // 数据总条数
        page: 1, // 默认显示第1页
        limit: 10, // 默认一次显示10条数据
        noData: this.$t("t.noDataNoOrder"),
        queryDate: {
          start_time: "",
          end_time: "",
        },
        subOrdersList: [],
        childTransactionId: "",
        paymentOrderVisible: false,
        appId: "",
        recurringBean: null
      }
    },
    components: {
      VirtualAccountDetailFilter,
      Pagination,
      Scrollbar,
    },
    watch: {
      currTimeZone: function () {
        this.queryDate.start_time = moment
          .tz(moment.tz(this.dateVals[0], this.currTimeZone), "UTC")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryDate.end_time = moment
          .tz(moment.tz(this.dateVals[1], this.currTimeZone), "UTC")
          .format("YYYY-MM-DD HH:mm:ss");
      },
      dateVals: function (val) {
        this.queryDate.start_time = moment
          .tz(moment.tz(val[0], this.currTimeZone), "UTC")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryDate.end_time = moment
          .tz(moment.tz(val[1], this.currTimeZone), "UTC")
          .format("YYYY-MM-DD HH:mm:ss");
      },
    },
    created() {
      this.dateVals.push(
        moment().subtract(31, "days").format("YYYY-MM-DD 00:00:00")
      );
      this.dateVals.push(moment().format("YYYY-MM-DD 23:59:59"));
      this.transferAccountBean = JSON.parse(localStorage.getItem("transferAccountBean"));
      this.queryDate.start_time = moment
        .tz(moment.tz(this.dateVals[0], this.currTimeZone), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
      this.queryDate.end_time = moment
        .tz(moment.tz(this.dateVals[1], this.currTimeZone), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
      this.searchOrder();

    },
    mounted() {
      // this.$refs.recurringsModal.ok = () => {};
      // 初始化
    },
    methods: {
      searchReset() {
        let filterArrayString = ["valueApp","valueCurrency","valueMethod","valueStatus","searchVal"]
        filterArrayString.forEach(value => {
          this.filterData[value] = "";
        })
        this.filterData.valueTime = "1";
        this.filterData.valueMode = "1";
        this.currTimeZone = "America/Sao_Paulo";
        this.dateVals = [];
        this.queryDate.start_time = "";
        this.queryDate.end_time = "";
      },
      searchOrder() {
        this.page = 1;
        this.orderData();
      },
      orderData() {
        this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
        let start = this.page;
        let end = this.limit;
        let token = localStorage.getItem("Authorization");
        request({
          method: "post",
          url: `api/dashboard/transfer/listTransactionsByPage?access_token=${token}`,
          data: {
            page_num: start,
            page_size: end,
            start_time: this.queryDate.start_time,
            end_time: this.queryDate.end_time,
            date_mode: this.filterData.valueTime,
            search_key: this.transferAccountBean.id,
            search_mode: "1",
          },
        })
          .then((res) => {
            if (!res) {
              this.searching.close();
              return;
            }
            if (res.data.code == 20000) {
              this.list = [];
              this.total = 0;
              this.noData = this.$t("t.noData");
              setTimeout(() => {
                this.searching.close();
              }, 200);
              return;
            }
            this.list = res.data.data.list;
            this.total = res.data.data.total;
            if (this.list.length === 0) {
              this.noData = this.$t("t.noData");
            }
            setTimeout(() => {
              this.searching.close();
            }, 800);
          })
          .catch((err) => {
            this.searching.close();
          });
      },

      isMobile: function () {
        if (document.body.clientWidth && document.body.clientWidth < 750) {
          return "mobile";
        }
        return "pc";
      },
      loadingFullScreen(controller, txt, className) {
        this[controller] = this.$loading({
          lock: true,
          text: txt,
          spinner: className,
          background: "rgba(0, 0, 0, 0.7)",
        });
      },
      dateFormat(value) {
        return moment
          .tz(moment.tz(value, "UTC"), this.currTimeZone)
          .format("YYYY-MM-DD HH:mm:ss");
      },
      getStatusColor(status) {
        // "Initial","Active","Charging","Controlling","Cancelled","Past Due","Closed","Refused"} return ;
        switch (status) {
          case "ACTIVE":
            return "#67c23a";
          case "ACTIVE":
            return "#909399";
          case "Charging":
            return "#67c23a";
          case "Past Due":
            return "#e6a23c";
          case "Controlling":
            return "#b1b8c5";
          case "CANCELED":
            return "#f56c6c";
          default:
            return "#909399";
        }

      },
    }
  }
</script>
<style lang="scss" scoped>
  table {
    text-align: center;
  }

  .alink {
    color: $vue-green;
    text-decoration: underline;
  }

  @media only screen and (max-width: 750px) {
    .mobile-btn {
      padding: 0.5rem 0.2rem 0;
    }

    /deep/ .pagination-container {
      padding: 5px 4px 10px;
      .el-pagination__total {
        display: block;
        margin-right: 4px;
      }
      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        margin: 0 2px 0;
      }
    }

    /deep/ .pagination-container {
      padding: 5px 4px 10px;
      .el-pagination {
        padding: 0;
        text-align: center;
      }
      .el-pagination__total {
        display: block;
        margin-right: 4px;
      }
      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        margin: 0 1px 0;
      }
    }

    /deep/ .buyer {
      padding-left: 5px;
      width: auto !important;
    }

    #details {
      min-width: 600px;
    }
  }
  /deep/ .el-pagination {
    text-align: center;
  }
  /deep/ .recurring-children {
    width: 300px;
    padding: 10px 20px;
    max-height: 350px;
    overflow-y: scroll;
    margin-top: -12px;
    li {
      list-style: none;
      cursor: pointer;
      color: #4ae387;
      text-decoration: underline;
      margin: 8px 0;
    }
  }
  /deep/ .recurrings-payment-order {
    .modal-dialog {
      margin-top: 0.2vh !important;
    }
    .recurrings-detail-content {
      max-height: 420px;
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }

  /deep/ .el-dialog {
    margin-top: 0.2vh !important;
    width: 98%;
  }
  /deep/ .el-dialog__header {
    padding: 10px 10px 0 !important;
  }
  /deep/ .el-dialog__headerbtn {
    position: absolute;
    top: 0;
    right: 5px;
    font-size: 30px;
  }
  /deep/ .el-dialog__title {
    font-size: 1.375rem;
    font-weight: 600;
  }
  /deep/ .el-dialog__body {
    padding: 30px !important;
  }


</style>
